import './App.css';
import './tailwind.generated.css';
import React, {useEffect} from "react";
import {
    ADMIN_ROLE,
    createLoginSession,
    DANCEPAY_ROLE, DANCER_CHECKIN,
    DRINKPAY_ROLE,
    EDITDANCER_ROLE, logOutSession,
    MOD_ROLE,
    PAYINVOICE_ROLE,
    PAYOUT_ROLE,
    SELL_ROLE,
    STAGEDISPLAY_ROLE,
    USER_ROLE
} from "./requests/AppSession";
import {useNavigate} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {findUserLoginSession} from "./virtualtips/requests/AppRequestAuth";
import {baseWebUrl} from "./requests/NetworkRequestAuth0";

function App() {

    let navigate = useNavigate();

    const [roles, setRoles] = React.useState([]);

    const {logout, user, isAuthenticated, isLoading, getAccessTokenSilently} = useAuth0();

    const submitSuccess = async responseJson => {
        if (
            responseJson &&
            responseJson.userType
        ) {
            await createLoginSession(
                responseJson.userId,
                responseJson.username,
                responseJson.email,
                user.email_verified,
                // responseJson["accessToken"],
                // responseJson["refreshToken"],
                responseJson.roles,
                responseJson.customerCode,
                responseJson.venueId,
                responseJson.dancerId,
                responseJson.privateDancePayFeatureFlag,
                responseJson.dancePayFeatureFlag,
                responseJson.drinkPayFeatureFlag,
                responseJson.stageTipFeatureFlag,
                responseJson.venueRewardsFeatureFlag,
                responseJson.venueStripePaymentsFeatureFlag,
                responseJson.venueInputCustomerCodePaymentsFeatureFlag,
                responseJson.venueScanCustomerCodePaymentsFeatureFlag,
                responseJson.dancerAppManagementFeatureFlag,
                responseJson.payoutPinNumberFeatureFlag,
                responseJson.payoutScanFeatureFlag
            );

            if (responseJson && responseJson.userType) {
                if (responseJson.roles) {
                    //setRoles(responseJson.roles.split(","));
                    setRoles(responseJson.roles);
                }
            } else {
                navigate('/signup/mobile', {replace: true});
            }

        } else {
            alert("ERROR2");
        }
    };

    const submitError = forceLogout => {
        //alert("ERROR");
        navigate('/login/mobile', {replace: true});

        //setIsSubmitting(false);
        //setErrorMessage("Email and Password Combination Incorrect");
    };

    const logOutAndValidateEmail = () => {
        logOutSession().then(() => {
            logout({ logoutParams: { returnTo: baseWebUrl + "/validateemail" } })
        })
    };

    useEffect(() => {

        if (isLoading) {
            return;
        }

        if (isAuthenticated) {
            findUserLoginSession(submitSuccess, submitError, getAccessTokenSilently);
        } else {
            navigate('/marketing', {replace: true});
        }
        //Fetch Login Session and set it and then getit out and use it


        // getLoginSession().then(loginSession => {
        //     if (loginSession && loginSession.userId) {
        //         if (loginSession.roles) {
        //             setRoles(loginSession.roles.split(","));
        //         }
        //     } else {
        //         navigate('/signup/mobile', {replace: true});
        //     }
        // })
        return function cleanup() {

        };
    }, [getAccessTokenSilently, isAuthenticated, isLoading, navigate, submitError, submitSuccess]);

    // useEffect(() => {
    //     //Fetch Login Session and set it and then getit out and use it
    //
    //     alert(roles);
    //
    //
    //     // getLoginSession().then(loginSession => {
    //     //     if (loginSession && loginSession.userId) {
    //     //         if (loginSession.roles) {
    //     //             setRoles(loginSession.roles.split(","));
    //     //         }
    //     //     } else {
    //     //         navigate('/signup/mobile', {replace: true});
    //     //     }
    //     // })
    //     return function cleanup() {
    //
    //     };
    // }, [roles]);


    return (
        <>
            {
                roles.includes(ADMIN_ROLE) ? navigate("/venue/dashboard", {replace: true}) :
                    roles.includes(MOD_ROLE) ? navigate("/selection", {replace: true}) :
                        roles.includes(SELL_ROLE) ? navigate("/sell", {replace: true}) :
                            roles.includes(PAYOUT_ROLE) ? navigate("/payout", {replace: true}) :
                                roles.includes(EDITDANCER_ROLE) ? navigate("/venue/dancer/edit", {replace: true}) :
                                    roles.includes(PAYINVOICE_ROLE) ? navigate("/venue/invoice", {replace: true}) :
                                        roles.includes(DANCEPAY_ROLE) ? navigate("/dance/sell", {replace: true}) :
                                            roles.includes(DRINKPAY_ROLE) ? navigate("/drink/sell", {replace: true}) :
                                                roles.includes(STAGEDISPLAY_ROLE) ? navigate("/stage/display", {replace: true}) :
                                                    roles.includes(DANCER_CHECKIN) ? navigate("/dancer/checkin", {replace: true}) :
                                                        (roles.includes(USER_ROLE) && user.email_verified) ? navigate("/find", {replace: true}) :
                                                        roles.includes(USER_ROLE) ? logOutAndValidateEmail() :
                                                            <></>
            }
            {/*{roles.includes(ADMIN_ROLE) ? <LandingAdminDashboard/> :*/}
            {/*    roles.includes(MOD_ROLE) ? <LandingDancerSelections/> :*/}
            {/*        roles.includes(SELL_ROLE) ? <LandingSellVT/> :*/}
            {/*            roles.includes(PAYOUT_ROLE) ? <LandingDancerPayoutBoard/> :*/}
            {/*                roles.includes(EDITDANCER_ROLE) ? <LandingAdminDancerEdit/> :*/}
            {/*                    roles.includes(PAYINVOICE_ROLE) ? <LandingAdminInvoices/> :*/}
            {/*                        roles.includes(DANCEPAY_ROLE) ? <LandingSellDance/> :*/}
            {/*                            roles.includes(DRINKPAY_ROLE) ? <LandingSellDrink/> :*/}
            {/*                                roles.includes(STAGEDISPLAY_ROLE) ? <LandingStageDisplay/> :*/}
            {/*                                    roles.includes(USER_ROLE) ? <LandingFindClub/> : <></>}*/}
        </>
    );
}

export default App;
